export default __webpack_public_path__ + "static/media/sd.73b28dc2.svg";